import { createApp } from '@app/adapters/create-app'
import UpdateLockedTemplateVersionsForm from './components/update-locked-template-versions-form.vue'

export const mountUpdateLockedTemplateVersions = (
  element: HTMLElement,
  props: {
    firmId: string
    loadTemplatesUrl: string
    loadCompaniesUrl: string
    formAction: string
    authenticityToken: string
  }
): void => {
  createApp(UpdateLockedTemplateVersionsForm, props).mount(element)
}
